export const CARD_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
      borderBottom: '1px solid #000000',
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};
